import axios from "../../../../../../api/axiosInstance";
import {
  CreateProductStoreCategoryRequest,
  CreateProductStoreCategoryResponse,
} from "./types";

export const createProductStoreCategory = async (
  data: CreateProductStoreCategoryRequest,
): Promise<CreateProductStoreCategoryResponse> => {
  const response = await axios.post<CreateProductStoreCategoryResponse>(
    "/api/private/product-store/categories",
    data,
  );
  return response.data;
};
